<template>
	<div class="workTaskSteps">
		<div class="steps">
			<span v-for="(item,index) in stepsList" :class="{'active':isActiveNums == index}"
				@click="stepsClick(index)">{{item}}</span>
		</div>
		<div class="stepBox">
			<template v-if="isActiveNums == 0">
				<First :work_task_id="detail.id" ref="first"></First>
				<div class="btns" v-if="btnShow">
					<el-button @click="isActiveNums = 1">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 1">
				<Work :work_task_id="detail.id" :image="work_image" ref="work" :is_edit="detail.is_edit"></Work>
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="isActiveNums = 0">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0">保存</el-button>
					<el-button @click="holdShow = true,is_next=1">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 2">
				<div class="bgCol third">

					<Part :work_task_id="detail.id" :images="part_start_images" ref="start" :type=2 :is_edit="detail.is_edit"></Part>

				</div>
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="isActiveNums = 1">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0">保存</el-button>
					<el-button @click="holdShow = true,is_next=1">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 3">
				<div class="bgCol fourth">
					<Part :work_task_id="detail.id" :images="part_end_images" ref="end" :type=3 :is_edit="detail.is_edit"></Part>

				</div>
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="isActiveNums = 2">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0">保存</el-button>
					<el-button @click="holdShow = true,is_next=1">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 4">
				<People :work_task_id="detail.id" :women_number="women_number" :man_number="man_number"
					ref="people" :is_edit="detail.is_edit"></People>

				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="isActiveNums = 3">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0">保存</el-button>
					<el-button @click="holdShow = true,is_next=1">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 5">

				<Last :work_task_id="detail.id" :is_edit="detail.is_edit"
					:task_complete_status="detail.task_complete_status" :content="detail.content"
					:is_weather="is_weather" ref="last"></Last>


				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="isActiveNums = 4">上一步</el-button>
					<el-button @click="holdShow = true">保存</el-button>
				</div>
			</template>
			<div class="btns">
				<el-button v-if="detail.task_status==200" @click="saveFarmStatus('300')">提交</el-button>
				<!-- <el-button v-if="detail.task_status==300" @click="saveFarmStatus('400')">审核</el-button> -->
				<el-button v-if="detail.task_status==300" @click="handleCheck(detail)">审核</el-button>
			</div>
		</div>

<WxMessageBox :show="checkShow" @save="checkSave" @canse="checkCanse">
		    <div slot="content">
				<el-form :model="checkForm" :rules="checkRules" ref="checkForm" label-width="0px">
		        <div class="personnel">
		            <div class="item_label">审核状态:</div>
		            <div class="radio_box">
						
						<el-form-item label="" prop="is_check">
							<el-radio-group v-model="checkForm.is_check">
							    <el-radio :label="1">审核通过</el-radio>
							    <el-radio :label="3">审核拒绝</el-radio>
							  
							  </el-radio-group>
						
						</el-form-item>
		            </div>
		        </div>
				<div class="personnel">
				    <div class="item_label">操作原因:</div>
				    <div class="radio_box">
						
						<el-form-item label="" prop="reason">
							<el-input
							  type="textarea"
							  :rows="2"
							  placeholder="请输入内容"
							  v-model="checkForm.reason">
							</el-input>
						
						</el-form-item>
				    </div>
				</div>
				     </el-form>
		    </div>
		</WxMessageBox>
		<WxMessageBox :show="holdShow" @save="holdSave" @canse="holdCanse">
			<div slot="content">
				<div class="word">
					<p>你是否确定保存目前最新的信息！</p>
				</div>
			</div>
		</WxMessageBox>
		
	</div>
</template>

<script>
	import {
		saveFarmWorkTaskMaterial,
		saveFarmWorkTaskStep,
		saveFarmTaskStatus,
		SaveFarmLastTaskStatus
	} from '@/api/step'
	import axios from 'axios';
	import Material from '@/components/children/Material';
	import People from '@/components/children/People';
	import Work from '@/components/children/Work';
	import Part from '@/components/children/Part';
	import First from '@/components/children/First';
	import Last from '@/components/children/Last';
	import WxMessageBox from '@/components/MessageBox';
	export default {
		name: "alibleTaskSteps",
		model: {
			prop: 'isActiveNum'
		},
		props: {
			isActiveNum: {
				type: Number,
				default: 1
			},
			detail: {
				type: Object,
				default: []
			},
			btnShow: {
				type: Boolean,
				default: true
			},
		},

		data() {
			return {
				is_weather: 1,
				is_next: 0,
				isActiveNums: 0,
				stepsList: ['第一步', '第二步', '第三步', '第四步', '第五步', '第六步'],
				holdShow: false,
				work_image: '',
				part_start_images: [],
				part_end_images: [],
				man_number: '',
				women_number: '',
				tableData: [],
				checkShow:false,
				        checkForm:{
				        	       work_task_id:'',
				        	       is_check:'',
								   task_status:400,
				        		   reason:'',
								   type:2,							 
				        },
				        checkRules: {
				        	is_check: [{required: true,message: '请选择审核状态',trigger: 'change'}],
				        	reason: [{required: true,message: '请输入操作原因',trigger: 'blur'}],
																	
				        },
			}
		},
		created() {
			console.log(this.detail.step)
			if (this.detail.step.length>0) {
				this.detail.step.forEach((item, index) => {
					if (item.type == 1) {
						this.work_image = item.content
					}
					if (item.type == 2) {
						this.part_images = item.content
					}
					if (item.type == 3) {
						this.man_number = item.content.man_number
						this.women_number = item.content.women_number
					}
					if (item.type == 4) {
						this.part_start_images = item.content
					}
					if (item.type == 5) {
						this.part_end_images = item.content
					}
				})
			}
		   this.tableData=this.detail.materials	
		},
		methods: {
			stepsClick(val) {
				this.isActiveNums = val
				this.$emit('stepsClick', val)
			},
			// 表格斑马纹
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 !== 1) {
					return 'single-row';
				} else {
					return 'double-row';
				}
			},
			// 发布弹窗确认
			checkSave(){
				console.log(this.checkForm)
				this.$refs["checkForm"].validate((valid) => {
					if (valid) {	
						saveFarmTaskStatus(this.detail.id, this.checkForm).then(resp => {
							this.$message.success(resp)
							//this.$emit("get_work_task")
							this.$parent.get_work_task();
						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			    
			},
			// 发布弹窗取消
			checkCanse(){
			    this.checkShow = false
			},
			handleCheck(row){
				console.log(row)
				this.checkForm.work_task_id=row.id
				//this.checkForm.is_check=row.is_check
				this.checkShow=true
			},
			// 保存弹窗
			holdSave() {

				if (this.isActiveNums == 1) {
					if (this.$refs.work.work_image == '') {
						this.$message.error("图片必须上传")
						this.holdShow = false
						return
					}
					let param = {
						type: 1,
						value: this.$refs.work.work_image
					}
					saveFarmWorkTaskStep(this.detail.id, param).then(resp => {
						this.$message.success("提交成功")
						this.holdShow = false
						this.$parent.get_work_task()
					})
				}
				if (this.isActiveNums == 2) {

					if (this.$refs.start.part_images.length != 3) {
						this.$message.error("图片必须上传3张")
						this.holdShow = false
						return
					}
					let param = {
						type: 4,
						value: this.$refs.start.part_images
					}
					saveFarmWorkTaskStep(this.detail.id, param).then(resp => {
						this.$message.success("提交成功")
						this.holdShow = false
						this.$parent.get_work_task()
					})
				}

				if (this.isActiveNums == 3) {
					if (this.$refs.end.part_images.length != 3) {
						this.$message.error("图片必须上传3张")
						this.holdShow = false
						return
					}
					let param = {
						type: 5,
						value: this.$refs.end.part_images
					}
					saveFarmWorkTaskStep(this.detail.id, param).then(resp => {
						this.$message.success("提交成功")
						this.holdShow = false
						this.$parent.get_work_task()
					})
				}
                if (this.isActiveNums == 4) {
					 let flag = this.$refs.people.validateForm();
					 if (flag) {
					 	let param = {
					 		type: 3,
					 		value: this.$refs.people.form
					 	}
					 	saveFarmWorkTaskStep(this.detail.id, param).then(resp => {
					 		this.$message.success("提交成功")
					 		this.holdShow = false
					 		this.$parent.get_work_task()
					 	})
					 } else {
					 	this.holdShow = false
					 }
					 
					}
				if (this.isActiveNums == 5) {

					let flag = this.$refs.last.validateForm();
					if (flag) {
						SaveFarmLastTaskStatus(this.detail.id, this.$refs.last.form).then(resp => {
							this.$message.success(resp)
							this.holdShow = false
							this.$parent.get_work_task();
						})
					}

				}
				
				if (this.is_next == 1) {
					this.isActiveNums = this.isActiveNums + 1;

				}
				console.log("aaaaa"+this.isActiveNums)
			},
			holdCanse() {
				this.holdShow = false
			},

saveFarmStatus(val){
				let param={task_status:val}
				 saveFarmTaskStatus(this.detail.id,param).then(resp=>{
					 this.$message.success(resp)
					//this.$emit("get_work_task")
					 this.$parent.get_work_task();
				 })
			},



		},
		components: {
			People,
			Part,
			Work,
			First,
			Last,
			Material,
			WxMessageBox
		}
	}
</script>

<style lang="less">
	
</style>
